import type { ProviderMatcher } from '../widgetMacroTypes.ts';

const MATCH_URL = 'flickr.com';

export const matchFlickr: ProviderMatcher = (url) => {
	if (!url.includes(MATCH_URL)) {
		return null;
	}
	// Legacy renderer relied on (a) Flash and (b) screen-scraping flickr.com to resolve
	// user ids server-side. Both are unsupported in the React renderer.
	return {
		kind: 'deprecated',
		provider: 'Flickr',
		embedUrl: url,
		width: '',
		height: '',
		hostLabel: 'flash-deprecated',
	};
};
